// Extended `process` polyfill: the standard browser polyfill plus the
// Electron/Node-specific members the renderer touches at runtime.
const base = require("process/browser");

// node/electron stay falsy so environment detection in libraries
// (iconv-lite, etc.) takes their browser code paths
const versions = {
    ...(base.versions ?? {}),
    node: "",
    chrome: "0.0.0-web",
    electron: "",
};

module.exports = Object.assign(base, {
    versions,
    pid: 1,
    argv: [],
    execPath: "/vortex/web",
    resourcesPath: "/vortex/web",
    contextIsolated: false,
    traceProcessWarnings: false,
    cwd: () => "/",
    getHeapStatistics: () => ({
        totalHeapSize: 0,
        usedHeapSize: 0,
        heapSizeLimit: 1024 * 1024,
    }),
    getSystemMemoryInfo: () => ({ total: 0, free: 0 }),
    getProcessMemoryInfo: () =>
        Promise.resolve({ private: 0, residentSet: 0, shared: 0 }),
    hrtime: Object.assign(
        (prev) => {
            const now = performance.now();
            const sec = Math.floor(now / 1000);
            const nano = Math.floor((now % 1000) * 1e6);
            if (prev !== undefined) {
                return [sec - prev[0], nano - prev[1]];
            }
            return [sec, nano];
        },
        { bigint: () => BigInt(Math.floor(performance.now() * 1e6)) },
    ),
});
